import React from "react";
import { Box, Typography } from "@mui/material";
import { Public } from "@mui/icons-material";
import { SPACING, ICON_SIZES } from "../../theme/constants";

const EmptyActivities = () => {
  return (
    <Box
      sx={{
        mt: SPACING.md,
        p: SPACING.xxxl,
        textAlign: "center",
        border: "2px dashed",
        borderColor: "divider",
        borderRadius: 3,
        bgcolor: "background.paper",
      }}
    >
      <Public
        sx={{
          fontSize: ICON_SIZES.xxl,
          color: "text.disabled",
          mb: SPACING.sm,
        }}
      />
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        No activities found
      </Typography>
      <Typography variant="body2" color="text.secondary">
        You haven't performed any recent actions yet.
      </Typography>
    </Box>
  );
};

export default EmptyActivities;
